import { Row, RowModel, flexRender } from '@tanstack/react-table';

interface LayoutTableRowsProps {
  rowModel: RowModel<any>;
  onClick?: (row: any) => void;
}

const LayoutTableRows: React.FunctionComponent<LayoutTableRowsProps> =
  function ({ rowModel, onClick }) {
    return (
      <tbody>
        {rowModel.rows.map((row: Row<any>, index: number) => (
          <tr
            key={row.id}
            className={[
              'cursor-pointer',
              index % 2 === 0 ? 'bg-neutral-000' : 'bg-neutral-200',
            ].join(' ')}
            onClick={onClick ? () => onClick(row) : () => {}}
          >
            {row.getVisibleCells().map((cell) => (
              <td key={cell.id} className="whitespace-nowrap py-0.5 px-1">
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  };

export default LayoutTableRows;
